/* Nordic Aim — hjälpare till Prisjakts "billigast"-widget.

   Widgeten skannar DOM en gång när den laddat. Vi ber den rita om när
   filtren bytt ut kollektionsrutnätet, och när man byter variant.

   OBS: widgetens egen städning gör
     for (const e of document.getElementsByClassName("prisjakt_cheapest_a")) e.outerHTML = "";
   vilket itererar en LEVANDE HTMLCollection samtidigt som element tas bort.
   Den missar därför varannan badge, och en omritning ger dubbletter.
   Vi städar själva med en statisk lista innan vi ber om omritning.

   Ingen MutationObserver här. Widgeten skriver in sina badgar i rutnätet,
   och en observer på rutnätet skulle trigga sig själv i all oändlighet. */
(function () {
  function purge() {
    var old = document.querySelectorAll('.prisjakt_cheapest_a');
    for (var i = 0; i < old.length; i++) {
      if (old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }
  }

  function reload() {
    if (!window.prisjakt_cheapest || typeof window.prisjakt_cheapest.reload !== 'function') return;
    purge();
    window.prisjakt_cheapest.reload();
  }

  var timer = null;
  function reloadSoon() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(reload, 120);
  }

  /* na-filters byter ut #ProductGridContainer och skickar detta när det är klart. */
  document.addEventListener('na:grid-updated', reloadSoon);

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var target = document.querySelector('.na-prisjakt-badge:not(.na-prisjakt-badge--card) .prisjakt_cheapest');
      var sku = event && event.data && event.data.variant ? event.data.variant.sku : null;
      if (!target || !sku || target.getAttribute('data-product') === sku) return;
      target.setAttribute('data-product', sku);
      reloadSoon();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
